export function ConfirmModal({ spinnerName, onConfirm, onCancel }) {
  return (
    <div className="ConfirmModal">
      <div className="confirm-message">
        <div className="confirm-title">
          "{spinnerName}"<br />
          Are you sure you want to delete this spinner?
        </div>
        <button className="confirm-yes" onClick={onConfirm}>
          DELETE SPINNER
        </button>
        <button className="confirm-no" onClick={onCancel}>
          CANCEL
        </button>
      </div>
    </div>
  );
}
